import Dialog from './Dialog';

const EditSuccessDialog = ({ onClose }: { onClose: () => void }) => {
  return (
    <Dialog
      title="Room has been changed successfully"
      onClose={() => onClose()}
      showFooter={false}
    >
      <div style={{ textAlign: 'center' }}>
        Your room has been changed now! It may take up to 24 hours before your
        map icon is approved.
      </div>
    </Dialog>
  );
};

export default EditSuccessDialog;
